import axios from 'axios';
// production url's
//let prodIdentityUrl = '';
//let prodApiUrl = '';
// development url's
let devIdentityUrl = 'https://revolutionlab-001-site14.anytempurl.com/api/Auth';
//let devApiUrl = 'https://revolutionlab-001-site16.anytempurl.com/api';
//let devApiUrl = 'https://161.97.107.219/api';
let devApiUrl = 'https://revolutionlab.cloud/api';

export const identityUrl = devIdentityUrl;

export const getSingleItem = (NameOfCallGroup) => {
    const url = identityUrl + `/signals/GetAllSignalsByCallGroupName/${NameOfCallGroup}`
    return axios.get(url).then(res => res.data)
    .catch((err) => {
        console.log(err)
    });
}

export const forgotPass = (body) => {
    const apiUrl = identityUrl +  '/forgot-password';
    const headers = {
        "Content-Type": "application/json"
    };
    return axios.post(apiUrl, body, {headers}).then((data) => {
        return data;
    })
}

export const loginUser = (body) => {
    const apiUrl = identityUrl +  '/login';
    const headers = {
        "Content-Type": "application/json"
    };
    return axios.post(apiUrl, body, {headers}).then((data) => {
        return data;
    })
}

export const registerUser = (body) => {
    const apiUrl = identityUrl +  '/register';
    const headers = {
        "Content-Type": "application/json"
    };
    return axios.post(apiUrl, body, {headers}).then((data) => {
        return data;
    })
}

export const getProductById = (id) => {
    const apiUrl = devApiUrl +  `/Products/${id}`;
    const headers = {
        "Content-Type": "application/json"
    };
    return axios.get(apiUrl, {headers}).then((data) => {
        return data;
    })
}

export const getAllProducts = () => {
    const apiUrl = devApiUrl +  `/Products/all`;
    const headers = {
        "Content-Type": "application/json"
    };
    return axios.get(apiUrl, {headers}).then((data) => {
        return data;
    })
}

//api/Products/by-manufacturer/{inManufacturer}

export const getProductsByBrand = (brand) => {
    const apiUrl = devApiUrl +  `/Products/by-manufacturer/${brand}`;
    const headers = {
        "Content-Type": "application/json"
    };
    return axios.get(apiUrl, {headers}).then((data) => {
        return data;
    })
}

export const createMoodboard = (body) => {
    const apiUrl = devApiUrl +  '/Moodboard';
    const headers = {
        "Content-Type": "application/json"
    };
    return axios.post(apiUrl, body, {headers}).then((data) => {
        return data;
    })
}

export const getAllMoodboards = (email) => {
    const apiUrl = devApiUrl +  `/MoodBoard/by-email?email=${email}`;
    const headers = {
        "Content-Type": "application/json"
    };
    return axios.get(apiUrl, {headers}).then((data) => {
        return data;
    })
}

export const addProductToMoodboard = (body, moodBoardId) => {
    const apiUrl = devApiUrl +  `/MoodBoard/${moodBoardId}/products`;
    const headers = {
        "Content-Type": "application/json"
    };
    return axios.post(apiUrl, body, {headers}).then((data) => {
        return data;
    })
}

export const removeFromMoodboard = (moodBoardId, productId) => {
    const apiUrl = devApiUrl +  `/MoodBoard/${moodBoardId}/products/${productId}`;
    const headers = {
        "Content-Type": "application/json"
    };
    return axios.delete(apiUrl, {headers}).then((data) => {
        return data;
    })
}

export const getMoodboardById = (id) => {
    const apiUrl = devApiUrl +  `/MoodBoard/${id}`;
    const headers = {
        "Content-Type": "application/json"
    };
    return axios.get(apiUrl, {headers}).then((data) => {
        return data;
    })
}

export const removeMoodboardById = (id) => {
    const apiUrl = devApiUrl +  `/MoodBoard/${id}`;
    const headers = {
        "Content-Type": "application/json"
    };
    return axios.delete(apiUrl, {headers}).then((data) => {
        return data;
    })
}

// end Moodboards

export const sendMessage = (body) => {
    const apiUrl = devApiUrl +  `/Contact/contact-message`;
    const headers = {
        "Content-Type": "application/json"
    };
    return axios.post(apiUrl, body, {headers}).then((data) => {
        return data;
    })
}

export const getEcontExpressOfices = () => {
    const apiUrl = `https://ee.econt.com/services/Nomenclatures/NomenclaturesService.getOffices.json`;
    const headers = {
        "Content-Type": "application/json"
    };
    return axios.get(apiUrl, {headers}).then((data) => {
        return data;
    })
}

export const finishOrder = (body) => {
    const apiUrl = devApiUrl +  `/SampleRequest`;
    const headers = {
        "Content-Type": "application/json"
    };
    return axios.post(apiUrl, body, {headers}).then((data) => {
        return data;
    })
}

export const sendMeetingRequest = (body) => {
    const apiUrl = devApiUrl +  `/Contact/meeting-request`;
    const headers = {
        "Content-Type": "application/json"
    };
    return axios.post(apiUrl, body, {headers}).then((data) => {
        return data;
    })
}